import { registerLocaleData } from "@angular/common";
import localeEs from "@angular/common/locales/es";
import localeJa from "@angular/common/locales/ja";
import { Component, inject, OnInit, signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";

import { WhiteLabelingDirective } from "directives/white-labeling-directive";
import { AmplitudeService } from "features/amplitude/services/amplitude.service";
import { LanguageFacade } from "state/language.facade";

import { GlobalLoadingOverlayComponent } from "./global-loading-overlay/global-loading-overlay.component";
import { LayoutComponent } from "./layout/layout.component";

registerLocaleData(localeEs);
registerLocaleData(localeJa);

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  hostDirectives: [WhiteLabelingDirective],
  standalone: true,
  imports: [LayoutComponent, GlobalLoadingOverlayComponent],
})
export class AppComponent implements OnInit {
  private readonly languageFacade = inject(LanguageFacade);
  private readonly amplitudeService = inject(AmplitudeService);

  public readonly orgRestored = signal(false);
  public readonly localizationReady = toSignal<boolean>(this.languageFacade.initialized$);

  public ngOnInit(): void {
    this.amplitudeService.initializeAmplitude();
  }
}
